import { NgModule } from '@angular/core';
import { SettingComponent } from './setting.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ImageCropperModule} from 'ng2-img-cropper';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from "../../shared/shared.module";
import { FocusDirective } from './focus.directive';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BrowserModule,
    SharedModule,
    ImageCropperModule
  ],
  declarations: [SettingComponent, FocusDirective]
})
export class SettingModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/setting/setting.module.ts